
import { computed, defineComponent, ref, watch } from "vue";

import {
  ColumnDefinition,
  useDataTable,
  DataTable,
  FormFieldRecommendedLengthInput,
  BaseButton,
  EditIcon,
} from "@tager/admin-ui";
import { getNameWithDepth } from "@tager/admin-services";
import { Page } from "@tager/admin-layout";

import { getSeoList, updateSeoForCategory } from "@/services/requests";
import { CategorySeoType } from "@/typings/model";
import { getProductListUrl, getCategoryFormUrl } from "@/utils/paths";
import { getWebsiteOrigin } from "@/utils/common";

const COLUMN_DEFS: Array<ColumnDefinition<CategorySeoType>> = [
  {
    id: 1,
    name: "ID",
    field: "id",
    style: { width: "50px", textAlign: "center" },
    headStyle: { width: "50px", textAlign: "center" },
  },
  {
    id: 2,
    name: "Название",
    field: "name",
    type: "name",

    format: ({ row }) => ({
      adminLink: {
        text: getNameWithDepth(row.name, row.depth),
        url: getCategoryFormUrl({ categoryId: row.id }),
      },
      websiteLink: {
        text: getWebsiteOrigin() + row.url,
        url: getWebsiteOrigin() + row.url,
      },
    }),
    style: { width: "200px" },
    headStyle: { width: "200px" },
  },
  {
    id: 3,
    name: "Заголовок страницы",
    field: "pageTitle",
    style: { minWidth: "220px", whiteSpace: "nowrap" },
    headStyle: { minWidth: "220px" },
  },
  {
    id: 4,
    name: "Описание страницы",
    field: "pageDescription",
  },
  {
    id: 5,
    name: "SEO Текст",
    field: "content",
    style: { width: "113px", whiteSpace: "nowrap" },
    headStyle: { width: "113px" },
  },
  {
    id: 6,
    name: "Actions",
    field: "actions",
    style: { width: "80px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "80px", textAlign: "center" },
  },
];

export default defineComponent({
  name: "SeoList",
  components: {
    Page,
    DataTable,
    FormFieldRecommendedLengthInput,
    BaseButton,
    EditIcon,
  },
  setup() {
    const values = ref<Array<{ pageTitle: string; pageDescription: string }>>(
      []
    );

    const {
      isLoading: isSeoListLoading,
      rowData: categoryList,
      errorMessage,
      searchQuery,
      handleChange,
      pageNumber,
      pageCount,
      pageSize,
      fetchEntityList,
    } = useDataTable<CategorySeoType>({
      fetchEntityList: (params) =>
        getSeoList({
          query: params.searchQuery,
          pageNumber: params.pageNumber,
          pageSize: params.pageSize,
        }),
      initialValue: [],
      pageSize: 30,
      resourceName: "Seo list",
    });

    watch(categoryList, () => {
      values.value = categoryList.value.map((category) => ({
        pageTitle: category.pageTitle ? category.pageTitle : "",
        pageDescription: category.pageDescription
          ? category.pageDescription
          : "",
      }));
    });

    const isRowDataLoading = computed<boolean>(() => isSeoListLoading.value);

    function updateSeo(id: number, pageTitle: string, pageDescription: string) {
      updateSeoForCategory(id, {
        title: pageTitle,
        description: pageDescription,
      });
    }

    return {
      columnDefs: COLUMN_DEFS,
      rowData: categoryList,
      isRowDataLoading,
      errorMessage,
      getCategoryFormUrl,
      getProductListUrl,
      searchQuery,
      handleChange,
      values,
      updateSeo,
      pageNumber,
      pageCount,
      pageSize,
    };
  },
});
